export default __webpack_public_path__ + "static/media/meetupjs_polygon.76f37bb8.png";